import apiClient from "../api/apiClient"
import { Customer, CreateCustomerForm } from "../../types"

interface CustomerApiResponse {
  info: {
    page: number
    limit: number
    total: number
    totalPages: number
    hasNextPage: boolean
  }
  results: Customer[]
}

export const customerService = {
  async getCustomers(params?: {
    page?: number
    limit?: number
    search?: string
    is_filer?: boolean
    booker_id?: string | string[]
    area_id?: string | string[]
  }): Promise<CustomerApiResponse> {
    const response = await apiClient.get<CustomerApiResponse>("/admin/customers/get-all", { params })
    return response.data
  },

  async getCustomerById(id: string): Promise<Customer> {
    const response = await apiClient.get<Customer>(`/admin/customers/${id}`)
    return response.data
  },

  async createCustomer(customerData: CreateCustomerForm): Promise<Customer> {
    const response = await apiClient.post<Customer>("/admin/customers/create", customerData)
    return response.data
  },

  async updateCustomer(id: string, customerData: Partial<CreateCustomerForm>): Promise<Customer> {
    const response = await apiClient.put<Customer>(`/admin/customers/${id}`, customerData)
    return response.data
  },

  async disableCustomer(id: string): Promise<void> {
    await apiClient.patch(`/admin/customers/${id}/status`)
  },

  async exportCustomersHtml(params?: {
    search?: string
    is_filer?: boolean
    booker_id?: string | string[]
    area_id?: string | string[]
  }): Promise<string> {
    const response = await apiClient.get<string>('/admin/customers/export-html', { params })
    return response.data
  },
}
